import { map, isEmpty } from 'lodash'

export const formattedAutocompleteList = (items, blankLabel) =>
  map(items, ({ name, uuid }) => {
    const safeName = isEmpty(name) ? blankLabel : name
    const firstLetter = safeName[0].toUpperCase()
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      value: uuid,
      label: safeName,
    }
  })
